const TEAMS: Record<string, { name: string; iso: string }> = {
  ALG: { name: "Algeria", iso: "DZ" }, ARG: { name: "Argentina", iso: "AR" },
  AUS: { name: "Australia", iso: "AU" }, AUT: { name: "Austria", iso: "AT" },
  BEL: { name: "Belgium", iso: "BE" }, BIH: { name: "Bosnia & Herzegovina", iso: "BA" },
  BRA: { name: "Brazil", iso: "BR" }, CAN: { name: "Canada", iso: "CA" },
  CHI: { name: "Chile", iso: "CL" }, CIV: { name: "Côte d’Ivoire", iso: "CI" },
  COD: { name: "DR Congo", iso: "CD" }, COL: { name: "Colombia", iso: "CO" },
  CPV: { name: "Cabo Verde", iso: "CV" }, CRO: { name: "Croatia", iso: "HR" },
  DEN: { name: "Denmark", iso: "DK" }, ECU: { name: "Ecuador", iso: "EC" },
  EGY: { name: "Egypt", iso: "EG" }, ENG: { name: "England", iso: "GB" },
  ESP: { name: "Spain", iso: "ES" }, FRA: { name: "France", iso: "FR" },
  GER: { name: "Germany", iso: "DE" }, GHA: { name: "Ghana", iso: "GH" },
  IRN: { name: "Iran", iso: "IR" }, ITA: { name: "Italy", iso: "IT" },
  JPN: { name: "Japan", iso: "JP" }, KOR: { name: "South Korea", iso: "KR" },
  KSA: { name: "Saudi Arabia", iso: "SA" }, MAR: { name: "Morocco", iso: "MA" },
  MEX: { name: "Mexico", iso: "MX" }, NED: { name: "Netherlands", iso: "NL" },
  NGA: { name: "Nigeria", iso: "NG" }, NOR: { name: "Norway", iso: "NO" },
  PAR: { name: "Paraguay", iso: "PY" }, PER: { name: "Peru", iso: "PE" },
  POR: { name: "Portugal", iso: "PT" }, RSA: { name: "South Africa", iso: "ZA" },
  SEN: { name: "Senegal", iso: "SN" }, SUI: { name: "Switzerland", iso: "CH" },
  SWE: { name: "Sweden", iso: "SE" }, URU: { name: "Uruguay", iso: "UY" },
  USA: { name: "United States", iso: "US" },
};

function flag(iso: string) {
  return [...iso].map((char) => String.fromCodePoint(127397 + char.charCodeAt(0))).join("");
}

export function TeamBadge({ code, compact = false }: { code: string; compact?: boolean }) {
  const info = TEAMS[code];
  return (
    <span className={`team-label ${compact ? "team-label--compact" : ""}`} title={info?.name || code}>
      {info && <span className="team-label__flag" aria-hidden="true">{flag(info.iso)}</span>}
      <span className="team-label__text">
        <strong>{code}</strong>
        {!compact && info && <small>{info.name}</small>}
      </span>
    </span>
  );
}
